import { queryClient } from "@/configs/react-query";
import { useTenantMemberships } from "@/contexts/TenantContext";
import LazoNotificationService from "@/services/LazoNotificationService";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

export const NOTIFICATIONS_QUERY_KEY = "notifications";

// ========== QUERIES ==========

export function useNotificationsCount() {
  const { currentTenantMembership } = useTenantMemberships();
  const tenantExternalId = currentTenantMembership?.tenant?.externalId;

  return useQuery({
    queryKey: [NOTIFICATIONS_QUERY_KEY, tenantExternalId],
    queryFn: () => LazoNotificationService.getCountNotifications(tenantExternalId).then((r) => r.getContentOrThrowError()),
    initialData: 0,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
  });
}

export function invalidateNotificationsCount() {
  queryClient.invalidateQueries({ queryKey: [NOTIFICATIONS_QUERY_KEY] });
}
